import { service } from '../index.js'

// 分类
export const category = {
  // 获取分类列表
  list: (params) => {
    return service.get('/category/list', { params })
  },
  
  // 获取素材分类
  materials: () => {
    return service.get('/category/materials')
  },
  
  // 后台：分类列表
  adminList: (params) => {
    return service.get('/category/admin/list', { params })
  },
  
  // 后台：保存分类
  save: (data) => {
    return service.post('/category/admin/save', data)
  },
  
  // 后台：删除分类
  delete: (data) => {
    return service.post('/category/admin/delete', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/category.js